import { getTopFiveLeagues } from "../../js/api/topfiveleague.js";
import { getTopTenMatchGames } from "../../js/api/toptenprematchgames.js";
import { getTopTenLiveGames } from "../../js/api/toptenlivegames.js";
import { sports } from '../components/Leftpanel.js';
import { getTopTenLiveTemplate } from "../templates/top-ten-live-games.js";
import { getFeaturedMatches, getTodayMatches } from "../../js/api/featuredPreMatch.js";
import { getPrematchGamesMainLeague } from "../../js/api/mainLeagueMatch.js";
import { getLiveTemplate } from "../templates/live-games.js";
import { _t } from "../../services/TranslationService.js";
import { LOGIN_PROTECTED } from "../../js/constants/global-variables.js";
import Utils from "../../services/Utils.js";


let timers = [];
let Landing = {
  render: async () => {
    if (LOGIN_PROTECTED === true && !localStorage.getItem('access_token')) {
      return '';
    }
    let sport_id = 1;
    let featuredPrematchs = await getFeaturedMatches(sport_id);
    let featuredPrematchView = '';
    let todayMatchesView = '';
    let mainLeagueMatches = await getPrematchGamesMainLeague();
    let todayMatches = await getTodayMatches();

    let mainLeagueMatchesView = '';

    let mainLeagueName = mainLeagueMatches && mainLeagueMatches[0] ? mainLeagueMatches[0].league : '';
  


    if (featuredPrematchs) {
      featuredPrematchs.forEach((featuredPrematch) => {

        if (featuredPrematch.odd) {
          featuredPrematchView = featuredPrematchView + `<div class="featuredPrematchItem">
             <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                <span>
                  <span class="kfm-Competitor_TeamKit">
                    <object data="${window.location.pathname}img/bluekit.svg" type="image/svg">
                      <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/bluekit.svg" />
                    </object>
                  </span>
                  ${featuredPrematch.home_team}
                </span>
                <span>
                  <span class="kfm-Competitor_TeamKit">
                    <object data="${window.location.pathname}img/redkit.svg" type="image/svg">
                      <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/redkit.svg" />
                    </object>
                  </span>
                  ${featuredPrematch.away_team}
                </span>
              </a>
              <span class="featurePreMatchDate">${Utils.formatDate(featuredPrematch.game_date, featuredPrematch.game_time, 'withoutYear')}</span>
                      <span class="numberofmarkets">${featuredPrematch.count_options} ></span>
              <div class="featuredMatchBtn">
                   <div class="singleHomeOdd bettingBtn ${Utils.formatNumber(featuredPrematch.odd.split(',')[0].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${featuredPrematch.odd.split(',')[0].split('|')[0]}" match-odd="${Utils.formatNumber(featuredPrematch.odd.split(',')[0].split('|')[1])}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[0].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[0].split('|')[0]}" match-market-option="1 " bet-id="${(featuredPrematch.odd.split(',')[0].split('|')[0])}" game-id="${featuredPrematch.id}"><i>1</i><i>${Utils.formatNumber(featuredPrematch.odd.split(',')[0].split('|')[1])}</i></div>
                   <div class="singleDrawOdd bettingBtn ${Utils.formatNumber(featuredPrematch.odd.split(',')[1].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${featuredPrematch.odd.split(',')[1].split('|')[0]}" match-odd="${Utils.formatNumber(featuredPrematch.odd.split(',')[1].split('|')[1])}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[1].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[1].split('|')[0]}" match-market-option="X " bet-id="${(featuredPrematch.odd.split(',')[1].split('|')[0])}" game-id="${featuredPrematch.id}"><i>X</i><i>${Utils.formatNumber(featuredPrematch.odd.split(',')[1].split('|')[1])}</i></div>
                   <div class="singleAwayOdd bettingBtn ${Utils.formatNumber(featuredPrematch.odd.split(',')[2].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${featuredPrematch.odd.split(',')[2].split('|')[0]}" match-odd="${Utils.formatNumber(featuredPrematch.odd.split(',')[2].split('|')[1])}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[2].split('|')[2]}" coef-id="${featuredPrematch.odd.split(',')[2].split('|')[0]}" match-market-option="2 " bet-id="${(featuredPrematch.odd.split(',')[2].split('|')[0])}" game-id="${featuredPrematch.id}"><i>2</i><i>${Utils.formatNumber(featuredPrematch.odd.split(',')[2].split('|')[1])}</i></div>
              </div>
        </div>`
        }
      });

    }


    if (todayMatches) {
      const uniqueLeaguesTodayMatches = [
        ...new Set(todayMatches.map((item) => item.league_id)),
      ];

      uniqueLeaguesTodayMatches.forEach((leagueId) => {
        let singleDateView = "";
        let leagueName = "";

        todayMatches
          .filter((a) => a.league_id === leagueId)
          .map((todayMatch) => {
            leagueName = todayMatch.league;

            if (todayMatch.odd) {
              try {
                singleDateView = singleDateView + `
                  <div class="featuredPrematchItem">
                    <div class="helperLeftContentMatch">
                      <a href="#/Match/${todayMatch.id}?today=1" class="featuredMatchName">
                        <span>${todayMatch.home_team}</span>
                        <span>${todayMatch.away_team}</span>
                      </a>
                      <span class="featurePreMatchDate">${Utils.formatDate(todayMatch.game_date, todayMatch.game_time, 'withoutYear')}</span>
                      <span class="numberofmarkets">${todayMatch.count_options} ></span>
                    </div>
                    <div class="featuredMatchBtn">
                      <div class="singleHomeOdd bettingBtn ${Utils.formatNumber(todayMatch.odd.split(',')[0].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${todayMatch.odd.split(',')[0].split('|')[0]}" match-odd="${Utils.formatNumber(todayMatch.odd.split(',')[0].split('|')[1])}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : todayMatch.odd.split(',')[0].split('|')[2]}"  match-market-option="1 " coef-id="${todayMatch.odd.split(',')[0].split('|')[0]}" bet-id="${(todayMatch.odd.split(',')[0].split('|')[0])}" game-id="${todayMatch.id}"><i>1</i><i>${Utils.formatNumber(todayMatch.odd.split(',')[0].split('|')[1])}</i></div>
                      <div class="singleDrawOdd bettingBtn ${Utils.formatNumber(todayMatch.odd.split(',')[1].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${todayMatch.odd.split(',')[1].split('|')[0]}" match-odd="${Utils.formatNumber(todayMatch.odd.split(',')[1].split('|')[1])}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : todayMatch.odd.split(',')[1].split('|')[2]}"  match-market-option="X " coef-id="${todayMatch.odd.split(',')[1].split('|')[0]}" bet-id="${(todayMatch.odd.split(',')[1].split('|')[0])}" game-id="${todayMatch.id}"><i>X</i><i>${Utils.formatNumber(todayMatch.odd.split(',')[1].split('|')[1])}</i></div>
                      <div class="singleAwayOdd bettingBtn ${Utils.formatNumber(todayMatch.odd.split(',')[2].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${todayMatch.odd.split(',')[2].split('|')[0]}" match-odd="${Utils.formatNumber(todayMatch.odd.split(',')[2].split('|')[1])}" match-home-name="${todayMatch.home_team}" match-away-name="${todayMatch.away_team}" match-market="${["1", "X", "2"].includes(todayMatch.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : todayMatch.odd.split(',')[2].split('|')[2]}"  match-market-option="2 " coef-id="${todayMatch.odd.split(',')[2].split('|')[0]}" bet-id="${(todayMatch.odd.split(',')[2].split('|')[0])}" game-id="${todayMatch.id}"><i>2</i><i>${Utils.formatNumber(todayMatch.odd.split(',')[2].split('|')[1])}</i></div>
                    </div>
                  </div>`;
              } catch {}
            }

          })
        todayMatchesView += `
          <div class="singleHeaderHolderLabel fourColumn">
          <div class="singleHeaderLabel">${leagueName}</div>
          <div class="singleHeaderLabel">1</div>
          <div class="singleHeaderLabel">x</div>
          <div class="singleHeaderLabel">2</div>
        </div>${singleDateView}`
      });


    }
    if (mainLeagueMatches) {


      mainLeagueMatches.forEach((mainLeagueMatche) => {
        if (mainLeagueMatche.odd) {
          mainLeagueMatchesView = mainLeagueMatchesView + `<div class="featuredPrematchItem">
                <a href="#/Match/${mainLeagueMatche.id}" class="featuredMatchName">
                  <span>
                    <span class="kfm-Competitor_TeamKit">
                      <object data="${window.location.pathname}img/bluekit.svg" type="image/svg">
                        <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/bluekit.svg" />
                      </object>
                    </span>
                    ${mainLeagueMatche.home_team}
                  </span>
                  <span>
                    <span class="kfm-Competitor_TeamKit">
                      <object data="${window.location.pathname}img/redkit.svg" type="image/svg">
                        <img class="ml-TeamKit_SVG" src="${window.location.pathname}img/redkit.svg" />
                      </object>
                    </span>
                    ${mainLeagueMatche.away_team}
                  </span>
                </a>
                <span class="featurePreMatchDate">${Utils.formatDate(mainLeagueMatche.game_date, mainLeagueMatche.game_time, 'withoutYear')}</span>
                        <span class="numberofmarkets">${mainLeagueMatche.count_options} ></span>
                <div class="featuredMatchBtn">
                     <div class="singleHomeOdd bettingBtn ${Utils.formatNumber(mainLeagueMatche.odd.split(',')[0].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${mainLeagueMatche.odd.split(',')[0].split('|')[0]}" match-odd="${Utils.formatNumber(mainLeagueMatche.odd.split(',')[0].split('|')[1])}" match-home-name="${mainLeagueMatche.home_team}" match-away-name="${mainLeagueMatche.away_team}" match-market="${["1", "X", "2"].includes(mainLeagueMatche.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : mainLeagueMatche.odd.split(',')[0].split('|')[2]}"  match-market-option="1 " coef-id="${mainLeagueMatche.odd.split(',')[0].split('|')[0]}" bet-id="${(mainLeagueMatche.odd.split(',')[0].split('|')[0])}" game-id="${mainLeagueMatche.id}"><i>1</i><i>${Utils.formatNumber(mainLeagueMatche.odd.split(',')[0].split('|')[1])}</i></div>
                     <div class="singleDrawOdd bettingBtn ${Utils.formatNumber(mainLeagueMatche.odd.split(',')[1].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${mainLeagueMatche.odd.split(',')[1].split('|')[0]}" match-odd="${Utils.formatNumber(mainLeagueMatche.odd.split(',')[1].split('|')[1])}" match-home-name="${mainLeagueMatche.home_team}" match-away-name="${mainLeagueMatche.away_team}" match-market="${["1", "X", "2"].includes(mainLeagueMatche.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : mainLeagueMatche.odd.split(',')[1].split('|')[2]}"  match-market-option="X " coef-id="${mainLeagueMatche.odd.split(',')[1].split('|')[0]}" bet-id="${(mainLeagueMatche.odd.split(',')[1].split('|')[0])}" game-id="${mainLeagueMatche.id}"><i>X</i><i>${Utils.formatNumber(mainLeagueMatche.odd.split(',')[1].split('|')[1])}</i></div>
                     <div class="singleAwayOdd bettingBtn ${Utils.formatNumber(mainLeagueMatche.odd.split(',')[2].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${mainLeagueMatche.odd.split(',')[2].split('|')[0]}" match-odd="${Utils.formatNumber(mainLeagueMatche.odd.split(',')[2].split('|')[1])}" match-home-name="${mainLeagueMatche.home_team}" match-away-name="${mainLeagueMatche.away_team}" match-market="${["1", "X", "2"].includes(mainLeagueMatche.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : mainLeagueMatche.odd.split(',')[2].split('|')[2]}"  match-market-option="2 " coef-id="${mainLeagueMatche.odd.split(',')[2].split('|')[0]}" bet-id="${(mainLeagueMatche.odd.split(',')[2].split('|')[0])}" game-id="${mainLeagueMatche.id}"><i>2</i><i>${Utils.formatNumber(mainLeagueMatche.odd.split(',')[2].split('|')[1])}</i></div>
                </div>
          </div>`
        }
      });
    }

    let sportsView = '';
    if (sports) {
      sports.forEach((sport) => {
        if (sport && (sport.id != 13 || sport.id != 15)) {
          sportsView = sportsView + `<a href="#/categories/${sport.id}" sportid="${sport.id}" class="betModuleSportBtn active hd-${sport.name}">
          <i class="sport-${sport.name}"></i>
          <span>${_t(sport.name)}</span>
        </a>`
        }

      });
    }




    let topFiveLeagues = getTopFiveLeagues().then((value) => {
      let getTopFiveLeaguesView = "";
      value.forEach((topFiveLeague) => {
        getTopFiveLeaguesView =
          getTopFiveLeaguesView +
          `<a class="leagueListContentItem" href="#/games/${topFiveLeague.id}" data-id="${topFiveLeague.id}">${topFiveLeague.name}</a>`;
      });

      document.getElementById(
        "leagueHeaderContentF"
      ).innerHTML = getTopFiveLeaguesView;

      updateMatch();
    });

    let topTenMatchGames = getTopTenMatchGames().then((value) => {
      let getTopTenMatchGamesView = "";
      value.forEach((topTenMatchGame) => {
        if (!topTenMatchGame.odd) {
          return;
        }
        getTopTenMatchGamesView =
          getTopTenMatchGamesView +
          `<div class="singleGameContent">
                           <a class="singleTeamNames" href="#/Match/${topTenMatchGame.id
          }" data-id="${topTenMatchGame.id}">
                               <div class="singleDateColumn">
                                  <span>${Utils.formatDate(topTenMatchGame.game_date, topTenMatchGame.game_time, 'timeOnly')}</span>
                        <span class="numberofmarkets">${topTenMatchGame.count_options} ></span>
                               </div>
                               <div class="singleDetailsColumn">
                                 <div class="singleTeamRowLabel">
                                   <span class="singleHomeName">${topTenMatchGame.home_team
          }</span>
                                   <span class="gameSingleHomeScore"></span>
                                 </div>
                                 <div class="singleTeamRowLabel">
                                   <span class="singleAwayName">${topTenMatchGame.away_team
          }</span>
                                   <span class="gameSingleAwayScore"></span>
                                 </div>
                               </div>
                           </a>
          <div
            class="singleHomeOdd bettingBtn  ${Utils.formatNumber(topTenMatchGame.odd.split(',')[0].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${topTenMatchGame.odd.split(",")[0].split('|')[0]}"
            match-odd="${Utils.formatNumber(topTenMatchGame.odd.split(',')[0].split('|')[1])}"
            match-home-name="${topTenMatchGame.home_team}"
            match-away-name="${topTenMatchGame.away_team}"
            match-market="Rezultat Final"
            match-market-option="1 "
            coef-id="${topTenMatchGame.odd.split(",")[0].split('|')[0]}"
            bet-id="${topTenMatchGame.odd.split(",")[0].split('|')[0]}"
            game-id="${topTenMatchGame.id}"
          >
            ${Utils.formatNumber(topTenMatchGame.odd.split(',')[0].split('|')[1])}
          </div>
          <div
            class="singleDrawOdd bettingBtn ${Utils.formatNumber(topTenMatchGame.odd.split(',')[1].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${topTenMatchGame.odd.split(",")[1].split('|')[0]}"
            match-odd="${Utils.formatNumber(topTenMatchGame.odd.split(',')[1].split('|')[1])}"
            match-home-name="${topTenMatchGame.home_team}"
            match-away-name="${topTenMatchGame.away_team}"
            match-market="Rezultat Final"
            match-market-option="X " coef-id="${topTenMatchGame.odd.split(",")[1].split('|')[0]}"
            bet-id="${topTenMatchGame.odd.split(",")[1].split('|')[0]}"
            game-id="${topTenMatchGame.id}"
          >
            ${Utils.formatNumber(topTenMatchGame.odd.split(',')[1].split('|')[1])}
          </div>
          <div
            class="singleAwayOdd bettingBtn ${Utils.formatNumber(topTenMatchGame.odd.split(',')[2].split('|')[1]) == 1 ? 'disabledBtn' : ''} ${topTenMatchGame.odd.split(",")[2].split('|')[0]}"
            match-odd="${Utils.formatNumber(topTenMatchGame.odd.split(',')[2].split('|')[1])}"
            match-home-name="${topTenMatchGame.home_team}"
            match-away-name="${topTenMatchGame.away_team}"
            match-market="Rezultat Final"
            match-market-option="2 "
            coef-id="${topTenMatchGame.odd.split(",")[2].split('|')[0]}"
            bet-id="${topTenMatchGame.odd.split(",")[2].split('|')[0]}"
            game-id="${topTenMatchGame.id}"
          >
            ${Utils.formatNumber(topTenMatchGame.odd.split(',')[2].split('|')[1])}
          </div>
        </div>`;
      });

      document.getElementById(
        "getTopTenMatchGamesViewF"
      ).innerHTML = getTopTenMatchGamesView;

      updateMatch();
    });
    let topTenLiveGames = getTopTenLiveGames().then((value) => {
      let getTopTenLiveGamesView = "";

      value.forEach((topTenLiveGame) => {
        if (topTenLiveGame.id != 372481) {
          getTopTenLiveGamesView =
            getTopTenLiveGamesView + getLiveTemplate(topTenLiveGame);

          const check = timers.find((a) => a.game_id == topTenLiveGame.id);
          const timerId = setInterval(() => liveTimer(`${topTenLiveGame.id}-timer`), 1000);
          if (check) {
            clearInterval(check.timerId);
            check.timerId = timerId;
          } else {
            timers.push({
              game_id: topTenLiveGame.id,
              timerId,
            });
          }
        }


      });
      document.getElementById(
        "getTopTenLiveGamesViewF"
      ).innerHTML = getTopTenLiveGamesView;

      updateMatch();
    });

    let view = /*html*/ `
          <div class="pageSection">
              <div class="firstColumn">
              <div class="betModule liveInModule sportsLanding">
                <div class="betModuleTabs">
                   <div class="betModuleTabsBtn">
                     ${sportsView}
                   </div>
                 </div>
               </div>
               <div class="jcakpotHolder jackpotHolderMain" hidden>
    <div class="jackpotHeader">
        <div class="jackpotLeftHeader">
            <span>${_t('Live jackpot')}</span>
            <span>${parseFloat(localStorage.getItem('jackpot_live') ? parseFloat(localStorage.getItem('jackpot_live')) : 0).toFixed(2)}&euro;</span>
        </div>
        <div class="jackpotRightHeader">
            <span>${_t('Prematch jackpot')}</span>
            <span>${parseFloat(localStorage.getItem('jackpot_prematch') ? parseFloat(localStorage.getItem('jackpot_prematch')) : 0).toFixed(2)}&euro;</span>
        </div>
    </div>
</div>
          <div class="betModule liveInModule accordionDisable" id="todayAccordion">
            <div class="betModuleHeaderContainer">
              <a class="betModuleHeaderBtn">
                <span>${_t('Ndeshjet Sot')}</span>
                <span class="yellowColored"></span>
              </a>
              <svg class="arrowDownIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve">
                  <g>
                  \t<path d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751   c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0   c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"/>
                  </g>
                </svg>
            </div>
          </div>
          <div class="featuredPrematchWrappers" id="todayAccordionContent">

              <div class="featuredPrematchSlider">

                  ${todayMatchesView}
              </div>
          </div>

            <div class="betModule liveInModule accordionDisable widthFull ${mainLeagueMatchesView == '' ? 'hideMe' : ''} " style="height: 34px; border-top: 1px solid var(--TitleBackBorderColor);">
                 <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <span style="line-height: 32px;">${mainLeagueName}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">

                   </a>
                 </div>
            </div>
            <div class="featuredPrematchWrapper widthFull" style="">
                <div class="featuredPrematchSlider ">
                    ${mainLeagueMatchesView}
                </div>
            </div>
            <div class="betModule liveInModule accordionDisable" style="height: 34px; ">
                <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <span style="line-height: 32px;">${_t('Ndeshjet Kryesore')}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">

                   </a>
                </div>
            </div>
            <div class="featuredPrematchWrapper">
                <div class="featuredPrematchSlider">
                    ${featuredPrematchView}
                </div>
            </div>
                <div class="betModule liveInModule accordionDisable">
                 <div class="betModuleHeaderContainer">
                   <a class="betModuleHeaderBtn">
                     <strong style="font-size: 21px"><span>${_t('NE KOHE')}</span>
                     <span class="yellowColored">${_t('REALE')}</span></strong>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">
                     <span>${_t('Te Gjitha Ndeshjet >')}</span>
                   </a>
                 </div>
                 <div class="singleHeaderHolderLabel fourColumn">
                      <div class="singleHeaderLabel">Soccer</div>
                      <div class="singleHeaderLabel">1</div>
                      <div class="singleHeaderLabel">x</div>
                      <div class="singleHeaderLabel">2</div>
                    </div>
                 <div class="betModuleContentContainer">
                   <div class="betModuleSportAccordion moduleFirstColour soccerTab">
                     <div class="moduleSportAccordionContent">
                       <div class="moduleSportSingleAccordion">
                         <div class="moduleSportSingleLeague">
                           <div class="moduleSportSingleLeagueContent gameTableContent" id="getTopTenLiveGamesViewF">
                           </div>
                           <a class="view-all-row" href="#/inPlay">
                            <span>${_t('Shiko te gjitha ne kohe reale')}</span>
                            <span>${_t('Te gjitha ndeshjet')}</span>
                           </a>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="gameTableHeader m-t-6">
                    <span class="gameTableHeaderTitle">${_t('Ndeshjet ne vijim')}</span>
                </div>
                <div class="singleHeaderHolderLabel fourColumn">
                      <div class="singleHeaderLabel">Soccer</div>
                      <div class="singleHeaderLabel">1</div>
                      <div class="singleHeaderLabel">x</div>
                      <div class="singleHeaderLabel">2</div>
                    </div>
                <div class="gameTableContent">
                     <div class="gameTableContent" id="getTopTenMatchGamesViewF">
                                             </div>
                </div>

                <div class="betModule liveInModule m-t-6 accordionDisable">
                     <div class="betModuleHeaderContainer makeFull">
                       <a class="betModuleHeaderBtn">
                         <span>${_t('Kampionatet kryesore')}</span>
                         <span class="yellowColored"></span>
                       </a>
                     </div>
                </div>
                <div class="leagueHeaderContent" id="leagueHeaderContentF">
                </div>
            </div>
       `;

    return view;
  },
  after_render: async (socket) => {
    if (LOGIN_PROTECTED === true && !localStorage.getItem('access_token')) {
      return;
    }

    $('body').on('click', '.sliderItemCasino', async function (e) {
      const event = new CustomEvent("loadLiveCasino", {
      });
      window.dispatchEvent(event);
    });


    $('body').on('click', '#todayAccordion', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleTodayAccordion($('body #todayAccordionContent').hasClass('show'));
    });



    socket.emit('connectToRoom', { room: "prematch-games" });
    socket.emit('connectToRoom', { room: "inplay" });
    $('body .menuItem a').removeClass('active');
    $('body .mainLeftMenuItem a').removeClass('active');
    $('body #inPlayPage').removeClass('active');
    $('body .leftMenuHome ').addClass('active');
    $('body .homeLeftBtn').addClass('active');
    $('body .betModuleTabs').css({
        'width': ($('.betModuleTabs .betModuleTabsBtn a:visible').length * 77) + 'px'
    });
    $('body .featuredPrematchWrapper').each(function () {
      let featuredSliderWidth = 0;
      $(this).children('.featuredPrematchSlider').children('.featuredPrematchItem').each(function () {
        featuredSliderWidth += $(this).outerWidth() + 2;
      });
      $(this).children('.featuredPrematchSlider').css({
        'width': featuredSliderWidth - 3 + 'px'
      });
    });

    toggleTodayAccordion(!(localStorage.getItem('today')));
    localStorage.removeItem('today');


  },
  on_unload: async (socket) => {
    socket.emit('leaveRoom', { room: "prematch-games" });
    socket.emit('leaveRoom', { room: "inplay" });
    clearTimers();
  },
};


function toggleTodayAccordion(show) {
  if (show) {
    $('#todayAccordion').removeClass('rotate');
    $('body #todayAccordionContent').removeClass('show');
    $('body #todayAccordionContent').css({
      'height': 0 + 'px'
    });
  } else {
    let getHeight = $('body #todayAccordionContent .featuredPrematchSlider').outerHeight();
    $('#todayAccordion').addClass('rotate');
    $('body #todayAccordionContent').addClass('show');
    $('body #todayAccordionContent').css({
      'height': getHeight + 'px'
    });
  }
}


function liveTimer(id) {
  const current_minute = $(`#${id}`).text();
  if (!current_minute || current_minute == "" || current_minute == "45:00")
    return;
  let minutes = parseInt(current_minute.split(":")[0]);
  let seconds = parseInt(current_minute.split(":")[1]);

  if (seconds == 59) {
    minutes += 1;
    seconds = 0;
  } else seconds += 1;

  $(`#${id}`).text(
    `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds
    }`
  );
}

function clearTimers() {
  if (!timers || (timers && timers.length === 0)) return;

  for (let i = 0; i < timers.length; i++) {
    const timer = timers[i];
    clearInterval(timer.timerId);
  }
}

export default Landing;
